/* ==========================================================================
   Veyra Deck — Blog yazısı içindekiler (TOC)
   Kaynak: cikti/blog-yapisi-v2-brief.md §3 + EK E5 (mobil öncelik)

   .vd-article__body içindeki h2'leri tarar, slug id atar ve
   nav.vd-article__toc içine liste basar.
   3'ten az h2 varsa konteyner DOM'dan tamamen SİLİNİR (boş kutu bırakılmaz).

   Mobil öncelik: işaretleme <details>/<summary>. Mobilde KAPALI başlar ve
   akışı iter — overlay değil, sabitlenmiş değil. 750px üzerinde açık açılır.

   Konteyner sunucudan `hidden` gelir; yalnızca liste gerçekten doldurulduysa
   görünür olur. Böylece boş kutu hiçbir an ekranda belirmez.
   ========================================================================== */

(function () {
  'use strict';

  var MIN_HEADINGS = 3;
  var DESKTOP_QUERY = '(min-width: 750px)';

  function slugify(text, fallbackIndex) {
    var slug = String(text || '')
      .toLowerCase()
      .replace(/[‘’“”]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    if (!slug) {
      slug = 'section-' + fallbackIndex;
    }

    return slug;
  }

  function build(container) {
    var body = container.querySelector('.vd-article__body');
    var toc = container.querySelector('.vd-article__toc');

    if (!body || !toc) {
      return;
    }

    var headings = body.querySelectorAll('h2');
    var list = toc.querySelector('.vd-article__toc-list');

    if (headings.length < MIN_HEADINGS || !list) {
      toc.parentNode.removeChild(toc);
      return;
    }

    var used = {};

    Array.prototype.forEach.call(headings, function (heading, index) {
      var id = heading.id;

      if (!id) {
        id = slugify(heading.textContent, index + 1);

        if (used[id]) {
          used[id] += 1;
          id = id + '-' + used[id];
        } else {
          used[id] = 1;
        }

        heading.id = id;
      }

      var li = document.createElement('li');
      li.className = 'vd-article__toc-item';

      var a = document.createElement('a');
      a.className = 'vd-article__toc-link';
      a.href = '#' + id;
      a.textContent = (heading.textContent || '').trim();

      li.appendChild(a);
      list.appendChild(li);
    });

    var details = toc.querySelector('details');

    if (details && window.matchMedia && window.matchMedia(DESKTOP_QUERY).matches) {
      details.open = true;
    }

    toc.hidden = false;
  }

  function init() {
    var containers = document.querySelectorAll('.vd-article');
    Array.prototype.forEach.call(containers, build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
